// extracted by mini-css-extract-plugin
module.exports = {"pageContainer":"CreateLeaderboardPage_pageContainer__2f7El","icons":"CreateLeaderboardPage_icons__3ne0X","formRow":"CreateLeaderboardPage_formRow__3dfH5"};